export const regroupModuleReducers = (modules) => {
    const reducers = {};
    modules.forEach(({ constants, reducer }) => {
        if (reducer) {
            reducers[constants.NAME] = reducer;
        }
    });
    return reducers;
};
